import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import UserSettingsFactory from "../../Entity/Factories/UserSettingsFactory";
import { ActionInterface } from "../../Interface/ActionInterface";
import { UserSettingsInterface } from "../../Entity/Entities/Settings/User/UserSettingsInterface";
import Translator from "../../Translation/Translator";

export default function* userSettingsUpdate(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.PAGE_SETTINGS_PREFERENCES_UPDATE_CLEAR
    });

    yield put({
      type: Constants.PAGE_SETTINGS_PREFERENCES_UPDATE_REQUEST
    });

    const res = yield call(Http.put, `user-settings/${action.payload?.preferences.userId}`, action.payload?.preferences);
    const settings: UserSettingsInterface = UserSettingsFactory.create(res.data);
    // We have to call onSuccess asap, otherwise reducers still use the old language.
    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, settings);
    }

    yield put({
      type: Constants.PAGE_SETTINGS_PREFERENCES_UPDATE_SUCCESS,
      payload: {
        settings: settings
      }
    });

    if (!action.payload?.preferences?.hideSnackbar) {
      yield put({
        type: Constants.SNACKBAR_ADD_MESSAGE,
        payload: {
          message: Translator.trans("snackbar-message-user-settings-updated-successfully"),
          type: "success"
        }
      });
    }
  } catch (err) {

    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.PAGE_SETTINGS_PREFERENCES_UPDATE_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchUserSettingsUpdate() {
  yield takeEvery(Constants.PAGE_SETTINGS_PREFERENCES_UPDATE_START, userSettingsUpdate);
}
